// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueLetterAvatar from 'vue-letter-avatar'
import VueAnalytics from 'vue-analytics'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { sync } from 'vuex-router-sync'

sync(store, router)

// For TkPictGridView.vue
Vue.use(Viewer)
Vue.use(VueLetterAvatar)

const isProd = process.env.NODE_ENV === 'production'
Vue.use(VueAnalytics, {
  id: 'UA-129504047-1',
  router,
  /*
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
  */
})

Vue.use(Vuetify, { theme: {
  primary: '#ee44aa',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  /*
  created() {
    this.$store.dispatch('fetchTkData')
  }
  */
})



// WEBPACK FOOTER //
// ./src/main.js